import { getGroupRoles } from "@/api/api";
import { useRequest } from "ahooks";
import { useState } from "react";

const useGetGroupsRoles = () => {
    const [ roles , setRoles ] = useState([]);
    
    const { run: fetchGroupsRoles, loading: groupsRolesLoading } = useRequest(getGroupRoles, {
        manual: true,
        onSuccess: (data) => {
            setRoles(data?.groupRoles)
        }
    })
    
    return {fetchGroupsRoles, groupsRolesLoading, roles};
}
 
export default useGetGroupsRoles;